module.exports = __webpack_public_path__ + "img/logo_fqm_preta.36a23628.svg";